import React from "react";
// const CreateBookedClass = React.lazy(() =>
//   import("../bookingClasses/CreateBookingClass")
// );
const Index = React.lazy(() => import("./index"));
const OrderDetails = React.lazy(() =>
  import("./OrderDetails")
);
// const ClassDetails = React.lazy(() => import("./ClassDetails"));

export const orderRoutes = [
  {
    path: "/admin/orderlist",
    name: "All Orders",
    element: <Index />,
  },
  {
    path: "/admin/orderlist/:id?",
    name: "Order Details",
    element: <OrderDetails />,
  },
  //   {
  //     path: "/admin/bookedclasses/(create|update)/:id?",
  //     exact: true,
  //     name: "Create book class",
  //     element:CreateBookedClass,
  //   },
  // {
  // 	path: "/admin/classes/:id?",
  // 	exact: true,
  // 	name: "Class",
  // 	element:ClassDetails,
  // },
];
